export const endpoints = {
    modulesSummary: '/catalog/modules/detail',
    module: '/catalog/modules/:name/metadata',
    moduleNomadConfiguration: '/catalog/modules/:name/config',
    moduleOscarConfiguration: '/inference/oscar/conf',
    trainModule: '/deployments/modules',
    trainTool: '/deployments/tools',
    deploymentByUUID: '/deployments/modules/:deploymentUUID',
    toolByUUID: '/deployments/tools/:deploymentUUID',
    deployments: '/deployments/modules',
    tools: '/deployments/tools',
    toolsSummary: '/catalog/tools/detail',
    tool: '/catalog/tools/:name/metadata',
    toolConfiguration: '/catalog/tools/:name/config',
    secrets: '/secrets',
    userStats: '/deployments/stats/user',
    clusterStats: '/deployments/stats/cluster',
    zenodo: '/proxies/zenodo',
    oscarServices: '/inference/oscar/services',
    oscarServiceByName: '/inference/oscar/services/:serviceName',
    nomadTryMeDeployments: '/try_me/nomad',
    nomadTryMeDeployment: '/try_me/nomad/:deployment_uuid',
    deploymentSnapshots: '/snapshots',
    snapshots: '/storage/:storage_name',
    batchDeployments: '/batch',
    batchDeploymentsByUUID: '/batch/:deploymentUUID',
    //OSCAR endpoints
    services: '/services',
    serviceByName: '/services/:name',
    runService: '/run/:name',
    // AI4Life modules
    ai4lifeModulesSummary:
        'https://raw.githubusercontent.com/ai4os/ai4os-ai4life-loader/main/models/filtered_models.json',
    // LLM chatbot
    chatCompletions: '/llm/chat',
    // LLM api keys (LiteLLM)
    litellm: '/llm/api_keys',
};
